<script setup>
/**
 * 接收父组件数据
 */
const props = defineProps({
  sidebarOpen: {
    type: Boolean,
    default: true
  },
  conversations: {
    type: Array,
    default: () => []
  },
  activeId: {
    type: String,
    default: null
  }
})

/**
 * 向父组件发送事件
 */
const emit = defineEmits([
    'create-chat',
    'select-chat',
    'show_product_description'
])
</script>

<template>
  <aside
      class="sidebar"
      :class="{ closed: !props.sidebarOpen }"
  >
    <div class="sidebar-inner">
      <!-- Logo -->
      <div class="sidebar-header">
        <div class="logo-box">
          <div class="logo-dot"></div>
          <span class="logo-brand">
          mcframe
          <small>Data Copilot</small>
        </span>
        </div>
      </div>

      <!-- 新规对话按钮 -->
      <button
          class="new-btn"
          @click="emit('create-chat')"
      >
        新規対話
      </button>

      <!-- 会话列表 -->
      <div class="sidebar-content">
        <div class="nav-label">最近の履歴</div>

        <div class="chat-list">
          <div
              v-for="chat in props.conversations"
              :key="chat.sessionId"
              :class="[
            'chat-item',
            chat.iconType || 'unit',
            { active: chat.sessionId === props.activeId }
          ]"
              @click="emit('select-chat', chat.sessionId)"
              :title="chat.title"
          >
            <!-- 标题 -->
            <span class="title-text">
            {{ chat.sessionTitle }}
          </span>
          </div>
        </div>
      </div>

      <button
          class="warring-btn"
          @click="emit('show_product_description')"
      >
        製品説明
      </button>

    </div>
  </aside>
</template>

<style scoped>

/* =============================
   Sidebar 主体
============================= */

.sidebar {
  width: 260px;
  background: #FFFFFF;
  border-right: 1px solid #E2E8F0;
  display: flex;
  flex-direction: column;
  transition: all 0.35s ease;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.02);
  z-index: 100;
  overflow: hidden;
}

.sidebar-inner {
  width: 260px;
  transition: transform 0.3s ease;

  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar.closed {
  width: 0;
}

/* =============================
   Header
============================= */

.sidebar-header {
  padding: 32px 24px 20px;
}
/* =============================
   Logo
============================= */

.logo-box {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #0066FF;
  box-shadow: 0 0 8px rgba(0, 102, 255, 0.35);
}

.logo-brand {
  font-size: 19px;
  font-weight: 800;
  letter-spacing: -0.6px;
  line-height: 1.1;
  background: linear-gradient(135deg, #003399 0%, #0066FF 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  flex-direction: column;
}

.logo-brand small {
  font-size: 10px;
  color: #94A3B8;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-top: 2px;
  -webkit-text-fill-color: #94A3B8;
}

/* =============================
   新规按钮
============================= */

.new-btn {
  width: calc(100% - 48px);
  margin: 8px auto 28px;
  height: 44px;
  border-radius: 12px;
  background: #F0F7FF;
  border: 1px solid rgba(0, 102, 255, 0.12);
  color: #0066FF;
  font-size: 13.5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.new-btn:hover {
  background: #E1EFFF;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(0, 102, 255, 0.12);
}

/* =============================
   列表区域
============================= */

.sidebar-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

/* 滚动条 */
.sidebar-content::-webkit-scrollbar {
  width: 6px;
}

.sidebar-content::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0);
  border-radius: 4px;
  transition: background 0.3s ease;
}

.sidebar-content:hover::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.4);
}


.nav-label {
  padding: 0 24px 12px;
  font-size: 11px;
  color: #94A3B8;
  letter-spacing: 1px;
}

/* =============================
   会话项
============================= */

.chat-list {
  flex: 1;
}

.chat-item {
  padding: 10px 16px;
  margin: 2px 12px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.25s ease;
}

.chat-item:hover {
  background: #F1F5F9;
}

.chat-item.active {
  background: #EBF5FF;
  border: 1px solid rgba(0, 102, 255, 0.08);
}

/* =============================
   标题
============================= */

.title-text {
  font-size: 13px;
  color: #475569;

  display: block;          /* 关键 */
  width: 100%;             /* 关键 */

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =============================
   图标
============================= */

.tech-icon-container {
  width: 16px;
  height: 16px;
  position: relative;
  flex-shrink: 0;
}

.icon-core {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #0066FF;
}

.icon-ring {
  position: absolute;
  inset: -3px;
  border: 1px solid rgba(0, 102, 255, 0.3);
  border-radius: 50%;
}

/* 不同 iconType 可以扩展 */

.chat-item.main .icon-core {
  background: #0066FF;
}

.chat-item.unit .icon-core {
  background: #6366F1;
}

/* =============================
   使用注意按钮
============================= */
.warring-btn {
  width: calc(100%);
  margin: 16px auto 24px;
  height: 40px;
  border-radius: 12px;
  background: #F8FAFF;
  border: 1px dashed rgba(0, 102, 255, 0.25);
  color: #0066FF;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.warring-btn:hover {
  background: #FFEAD5;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(249, 115, 22, 0.15);
}

</style>
